import React, { useCallback, useRef, useEffect, useState } from 'react';

import { Form } from '@unform/web';
import { Container } from './styles';
import { hour, dateLanguage } from '../../utils/date';
import api from '../../services/api';
import Vimeo from '../Vimeo';

import PosterZoomComponent from '../CientificLibraryRoom';
import { Button } from '../Button/styles';
import { rgb, rgba } from 'polished';
import Favorite from '../ClassRoomContainer/modules/Favorite';
import { FaBook, FaSearch, FaStar } from 'react-icons/fa';
import { useLanguage } from '../../hooks/Language';
import { string } from 'yup';
import themeDefault from '../../styles/ThemeComponents';
import { urlWebsite } from '../../config';
import { useAuth } from '../../hooks/Auth';
import { useParams } from 'react-router-dom';

interface IPoster {
  id : number;
  keywords : Array<string>;
  star?: number;
  title?: string;
  nested_authors?: string;
  author?: string;
  image?: string;
  video_type?: number;
  video_id: string;
  co_authors?: string;
  category?: string;
  have_video?: number;
  eixo ?: string;
  pdf ?: string;
  pdf_image?: Array<Record<string,any>>;
  time_to_read ?: string; 
}

interface IOption {
  page: number;
  order: Record<string,string>;
  where: Record<string, any>;
}

interface IStars {
  stars : number;
}

 

export const track = ( { id = '', title = '', reference = '', track = '', client_id = '', client_name }) => {

/* ID do trabalho
titulo do trabalho
reference é a ação
track o que é

*/

   api.post('/add-track', { id, title, reference, track , client_id : client_id, client_name, project_id: 'cientific-library' });


}
 
export const ShowStars: React.FC<IStars> = ({stars = 5}) => {

  return <div className='starCase'>

  <FaStar size={15} style={{color: stars >= 1 ? '#f15a23' : '#fff'}} />
  <FaStar size={15} style={{color: stars >= 2 ? '#f15a23' : '#fff'}} />
  <FaStar size={15} style={{color: stars >= 3 ? '#f15a23' : '#fff'}} />
  <FaStar size={15} style={{color: stars >= 4 ? '#f15a23' : '#fff'}} />
  <FaStar size={15} style={{color: stars >= 5 ? '#f15a23' : '#fff'}} />
  </div>

}

const CientificLibraryComponent: React.FC = () => {
  const [posters, setPosters] = useState<Array<IPoster>>([]);
  const [selectedPoster, setSelectedPoster] = useState<string>(''  );

  const {posterid} = useParams<Record<string,any>>();

  const [openPoster, setOpenPoster] = useState(false);
  const [loading, setLoading] = useState(true);
  const [counter, setCounter] = useState(1);
  const [search, setSearch] = useState('');
  const [haveSelector, setHaveSelector] = useState(false);
  const [category, setCategory] = useState('');
  const [eixos, setEixos] = useState<Array<string>>([]);
  const {user} = useAuth();
  const [options, setOptions] = useState<IOption>({
    page: 1,
    order: {orderBy : 'title', direction: 'asc'},
    where: {},
  });
const { translate} = useLanguage();

useEffect(() => {

if(posterid){
  setSelectedPoster(posterid);
  setOpenPoster(true);
}

},[posterid])


  const readEixos = ( list : Array<Record<string,any>>) => {


    if(eixos.length < 1 && list?.length > 0){

      let newEixos : Array<string> = [];

      list.map( (item) => {

        if(item?.keywords?.length > 0){
          item.keywords.map( (key : string) => {
            const index = newEixos.findIndex( listedKey => listedKey === key);
            
            if(index < 0){
              newEixos.push(key);
            }
          })
        }


      })

      newEixos.sort( (a,b) => a > b ? 1 : a < b ? -1 : 0);
      setEixos(newEixos);


      
    }


  }

  const loadSearch = async ({join = false, page = 0, text = ''}) => {
    const string = `search=${encodeURIComponent(
      text || search || '',
    )}&order=${encodeURIComponent(JSON.stringify(options.order))}&page=${
      page > 0 ? page : options.page
    }&where=${encodeURIComponent(JSON.stringify(options.where))}`;

    const response = await api.get(`/list-cientific-library?${string}`);

   

    if (response && response.data && response.data.rows) {
      const responseData = response.data.rows.reduce((prev, elem) => {
        elem.formatted_date = dateLanguage(elem.date);
        elem.formatted_start_hour = hour(elem.start_hour);
        elem.formatted_end_hour = hour(elem.end_hour);
        if(!elem.keywords){
          elem.keywords = [];
        }
        prev.push(elem);
       

        return prev;
      }, []);

      if (join) {
        setPosters([...posters, ...responseData]);
      } else {
        setPosters([...responseData]);
      }

      setCounter(response.data.count / 20 < 1 ? 1 : response.data.count / 20);


      readEixos(response.data.rows);

    } else {
      setPosters([]);
      setCounter(1);
    }
    setLoading(false);
  };



  const newSearch = () => {
    const newOptions = { ...options };
    newOptions.page = 1;
    setOptions({ ...newOptions });
    loadSearch({});
    setSearch('');
  };

  const changeOrder = (value,direction) => {

    const newOptions = {...options};

    newOptions.order = { orderBy : value, direction};

    setOptions(newOptions);
    loadSearch({});

  }

  const loadEixos = async () => {
    /* const response = await api.get(`/poster-list-eixo`);


    if(response){
      const eixo : Array<string> = [];
      response.data.map( (r ) => {
        if(r.eixo){
          eixo.push(r.eixo);
        }
      })

      setEixos(eixo);
    } */

  }

  useEffect(() => {
    loadEixos();
    const load = async () => {
      loadSearch({});
    };
    load();

    track({ id: '', title: 'Biblioteca', reference: 'Visita', track: 'Acesso', client_name: user?.name || '', client_id : user?.id || ''})
  }, []);

  const closePoster = () => {
    setOpenPoster(false);
  };

  const showPoster = poster => {
    setSelectedPoster(poster.url);
    setOpenPoster(true);
  };

  if (openPoster) {
    return (<div style={{width: '100%', display:'flex', alignItems: 'center', justifyContent:'center', flexDirection:'column'}}>
      <button className='closeButton' style={{margin: '10px auto'}} onClick={() => setOpenPoster(false)}>Voltar</button>
      <PosterZoomComponent
        closePoster={closePoster}
        posterID={selectedPoster}
        closeFunction={() => setOpenPoster(false)}
      /></div>
    );
  }

  const addPage = () => {
 
    setOptions((state) => {
      state.page += 1;
      loadSearch({ join : true,page : state.page});
      return state
    });

    
  };

  const changeCategory = (column,categoryName) => {
    const newOptions = { ...options };
    if(categoryName === ''){
      newOptions.where = {};
      setOptions({ ...newOptions });
      loadSearch({});
      if(categoryName === 'have_video'){
      setCategory(categoryName);
      }
      return;

    }

   
    const newCategory =
      newOptions.where && newOptions.where[column] === categoryName
        ? ''
        : categoryName;
    newOptions.page = 1;
    if (newCategory === '' && newOptions.where[column]) {
      delete newOptions.where[column];
    } else {
      newOptions.where[column] = newCategory;
    }

    setOptions({ ...newOptions });
    loadSearch({});
    setCategory(newCategory);
  };

  const addAndSearch = ( text) => {
 
    
    loadSearch({text});
    
  }

  const getColor = categoryName => {
    if (categoryName === 'Apresentação Oral') {
      return 'borderBlue';
    }
    if (categoryName === 'Pôster Comentado') {
      return 'borderPurple';
    }
    if (categoryName === 'Pôster Simples') {
      return 'borderGreen';
    }
  };

  return (
    <Container>
      <div className="posterSelector">
   
       { haveSelector && <> 
        <Button
          className={category === '1' ? 'active' : ''}
          onClick={() => changeCategory('have_video', '1')}
          type="button"
        >
          Pôster
        </Button>
        <Button
          className={category === '2' ? 'active' : ''}
          onClick={() => changeCategory('have_video', '2')}
          type="button"
        >
          Apresentação Oral
        </Button></>}

   
      
       <div className='posterHeader' >
        
       <h1>Biblioteca Científica</h1>
         <div className='posterSearch'> 
      <select   onChange={(e) => addAndSearch(e.target.value)}>
        <option value={''}>{translate('Selecionar temática')}</option>
        {eixos.map( eixo =>  <option value={eixo}>{eixo}</option>)}
       
      </select>
    
         
        <Form
          style={{ display: 'flex', alignItems: 'stretch', background:'none' }}
          onSubmit={newSearch}
        >
          
           
          <input  
            name="pesquisa"
            type="text"
            placeholder={`${translate('Escreva para pesquisar')}...`}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

        <button   type="submit"><FaSearch/></button>
        </Form>

         </div>
        </div>
      </div>
      <div className="mainPoster">
        {!loading && posters.length < 1 && <h2>Nenhum trabalho encontrado</h2>}
        {posters.map(poster => {
          return (<div style={{display:'flex', alignItems:'stretch', justifyContent:'center', position:'relative'}}>
            <div key={`posterDiv${poster.id}`} style={{position:'relative'}}
              className={`posterDisplay ${getColor(poster.category)}`}
              onClick={() => showPoster(poster)}
            >  
              <div className='posterImageDiv'>
                <img 
                  className="posterImage"
                  src={poster.image ? `${urlWebsite}/${poster.image}` : '/apoio/biblioteca/capa.jpeg'}
                />
                </div>
             
            <div className='posterContent'>
            
                <h2> {poster.title}</h2>
            
              
              <p className="posterAuthor">
            
 
                {poster.nested_authors}
      
              </p>

              {poster?.keywords?.length > 0 && <div className='posterKeywords'>
                {poster?.keywords?.length > 0 && poster.keywords.map( (keyword,indexKeyword) => {

                  return indexKeyword <= 2 ? <strong>{keyword} </strong> : <></>

                })}

                </div> }
<div className='starsTime' style={{display:'flex', justifyContent:'flex-start', alignItems: 'center', marginTop: '10px'}}>
             { poster.time_to_read && <> <ShowStars stars={poster?.star || 5} />  <FaBook   /> <p style={{fontSize: '12px',minWidth: '130px'}}>{poster.time_to_read} minutos de leitura</p></>}
</div>
       
              </div>
            </div>
         
            </div>
          );
        })}
      </div>
      <div className="mainFooter">
        {counter > options.page && (

<button
className="closeButton"
type="button"
style={{marginBottom: '25px'}}
onClick={() => addPage()}
 
>
Carregar Mais
</button>
         
        )}
      </div>
    </Container>
  );
};
export default CientificLibraryComponent;
